// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1bwH3","label":"Labeled_label__2OX5K","divider":"Labeled_divider__2qclf"};